import React, { Component } from "react";

import "./smart-checkbox.css";

class SmartCheckbox extends Component {

    update(e) {
        let { on_change, config } = this.props;
        let newValue = e.target.checked;
        on_change(config.name, newValue);
    }

    render() {
        let { config, value } = this.props;
        let label = config.label;
        let name = config.name;
        let isChecked = value;

        if (isChecked === undefined) {
            isChecked = false;
        }

        return (
            <div>
                <label htmlFor={name}>{label}</label>
                <input type="checkbox" className="regular-checkbox" name={name} checked={isChecked} onChange={this.update.bind(this)} />
            </div >
        );
    }
}

export default SmartCheckbox;


// WEBPACK FOOTER //
// ./src/components/components/smart-form/smart-checkbox.js